// Adds commas to every thousands place of a number string
// H/T for regex https://blog.abelotech.com/posts/number-currency-formatting-javascript/
function addCommas(numberString) {
  return numberString.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

// Returns a number string with commas for every thousands place
// Example: formatNumber(1000.1) returns '1,000.1'
function formatNumber(number) {
  number = number.toString();

  if (number.includes('.')) {
    const split = number.split('.');

    split[0] = addCommas(split[0]);

    return split.join('.');
  }

  return addCommas(number);
}

// Returns a number converted to a given value
// Example: roundNumber(1999985000, 'millions') returns '1999.985'
// Structure H/T https://www.react-simple-maps.io/examples/map-chart-with-tooltip/
function convertNumber(number, convertTo) {
  if (convertTo === 'trillions') {
    number /= 1000000000000;
  } else if (convertTo === 'billions') {
    number /= 1000000000;
  } else if (convertTo === 'millions') {
    number /= 1000000;
  } else if (convertTo === 'thousands') {
    number /= 1000;
  }

  return number;
}

// Returns a formatted number string rounded to a given value, adding as many decimals as specified
// Example: roundNumber(1999985000, 'millions', 2) returns '1,999.99'
function roundNumber(number, convertTo, decimals = 0) {
  number = convertNumber(number, convertTo);

  if (decimals === 'all') {
    return formatNumber(number);
  }

  // Decimals rounding H/T https://www.jacklmoore.com/notes/rounding-in-javascript/
  return formatNumber(Number(`${Math.round(`${number}e${decimals}`)}e-${decimals}`));
}

export { roundNumber };
